var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.detailLoading } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c("admin-breadcrumb", {
                attrs: { name: "Universal Directory" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right align-self-end", attrs: { sm: "6" } },
            [
              _vm.canCreate
                ? _c(
                    "b-button",
                    {
                      staticClass: "mb-4",
                      attrs: { variant: "success" },
                      on: { click: _vm.openCreate },
                    },
                    [_vm._v("\n        Add contact\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "admin-panel",
        { attrs: { "with-footer": "" } },
        [
          _c(
            "b-form",
            {
              staticClass: "directory-filters",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.search.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "directory-filter-row" },
                [
                  _c(
                    "b-input-group",
                    { staticClass: "directory-search" },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "directory-search",
                          "aria-label": "Search contacts and companies",
                          placeholder:
                            "Name, company, DBA, email, phone or license",
                        },
                        on: { input: _vm.scheduleSearch },
                        model: {
                          value: _vm.filters.search,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "search", $$v)
                          },
                          expression: "filters.search",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                type: "submit",
                                variant: "primary",
                                disabled: _vm.loading,
                              },
                            },
                            [
                              _vm.loading
                                ? _c("b-spinner", {
                                    staticClass: "mr-1",
                                    attrs: { small: "", "aria-hidden": "true" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n\n              " +
                                  _vm._s(
                                    _vm.loading ? "Searching…" : "Search"
                                  ) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "sr-only",
                      attrs: { for: "directory-states" },
                    },
                    [_vm._v("\n          States\n        ")]
                  ),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "directory-states",
                    attrs: {
                      "input-id": "directory-states",
                      multiple: "",
                      options: _vm.stateOptions,
                      reduce: (option) => option.value,
                      placeholder: "All States",
                    },
                    model: {
                      value: _vm.filters.states,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "states", $$v)
                      },
                      expression: "filters.states",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "directory-filter",
                    attrs: {
                      options: _vm.accountOptions,
                      "aria-label": "Account status",
                    },
                    model: {
                      value: _vm.filters.account_status,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "account_status", $$v)
                      },
                      expression: "filters.account_status",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "directory-filter-row" },
                [
                  _c("b-form-select", {
                    staticClass: "directory-filter",
                    attrs: {
                      options: _vm.licenseTypeOptions,
                      disabled:
                        _vm.filterOptionsLoading ||
                        Boolean(_vm.filterOptionsError),
                      "aria-label": "License type",
                    },
                    model: {
                      value: _vm.filters.license_type_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "license_type_id", $$v)
                      },
                      expression: "filters.license_type_id",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "directory-filter",
                    attrs: {
                      "aria-label": "Role or title",
                      placeholder: "Role / title",
                    },
                    model: {
                      value: _vm.filters.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "title", $$v)
                      },
                      expression: "filters.title",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "directory-filter",
                    attrs: {
                      options: _vm.companyStatusOptions,
                      disabled:
                        _vm.filterOptionsLoading ||
                        Boolean(_vm.filterOptionsError),
                      "aria-label": "Company status",
                    },
                    model: {
                      value: _vm.filters.company_status_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "company_status_id", $$v)
                      },
                      expression: "filters.company_status_id",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-form-select", {
                    staticClass: "directory-filter",
                    attrs: {
                      options: _vm.sourceOptions,
                      "aria-label": "Contact source",
                    },
                    model: {
                      value: _vm.filters.source,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "source", $$v)
                      },
                      expression: "filters.source",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { attrs: { type: "submit", variant: "outline-primary" } },
                    [_vm._v("\n          Apply filters\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { attrs: { variant: "link" }, on: { click: _vm.reset } },
                    [_vm._v("\n          Clear\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "mt-3",
              attrs: {
                show: Boolean(_vm.filterOptionsError),
                variant: "warning",
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.filterOptionsError) + "\n\n      "
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    type: "button",
                    size: "sm",
                    variant: "outline-secondary",
                    disabled: _vm.filterOptionsLoading,
                  },
                  on: { click: _vm.loadFilterOptions },
                },
                [_vm._v("\n        Retry\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "mt-3",
              attrs: { show: Boolean(_vm.error), variant: "danger" },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.error) + "\n\n      "),
              _c(
                "b-button",
                { attrs: { size: "sm" }, on: { click: _vm.load } },
                [_vm._v("\n        Retry\n      ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted my-2" }, [
            _vm._v("\n      " + _vm._s(_vm.total) + " contacts\n      "),
            _vm.resultSearch
              ? _c("span", [_vm._v("\n        · Most relevant first\n      ")])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("b-table", {
            attrs: {
              items: _vm.contacts,
              fields: _vm.fields,
              "primary-key": "key",
              responsive: "",
              "show-empty": "",
              busy: _vm.loading,
              "empty-text": "No contacts match your search.",
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-center py-3",
                        attrs: { role: "status" },
                      },
                      [
                        _c("b-spinner", {
                          staticClass: "mr-2",
                          attrs: { small: "" },
                        }),
                        _vm._v("\n          Searching contacts…\n        "),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(name)",
                fn: function ({ item }) {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "p-0 text-left",
                        attrs: { variant: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.showContact(item)
                          },
                        },
                      },
                      [
                        _c("admin-directory-highlight", {
                          attrs: {
                            text: _vm.contactName(item),
                            search: _vm.resultSearch,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-muted" },
                      [
                        _c("admin-directory-highlight", {
                          attrs: { text: item.title, search: _vm.resultSearch },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(contact)",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      [
                        _c("admin-directory-highlight", {
                          attrs: {
                            text: item.email || "—",
                            search: _vm.resultSearch,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("admin-directory-highlight", {
                          attrs: {
                            text: item.phone || "—",
                            search: _vm.resultSearch,
                            normalize: "phone",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(company)",
                fn: function ({ item }) {
                  return _vm._l(
                    item.relationships || [],
                    function (relationship, index) {
                      return _c(
                        "div",
                        {
                          key: `${item.key}-relationship-${index}`,
                          staticClass: "mb-2",
                        },
                        [
                          _c(
                            "strong",
                            [
                              _c("admin-directory-highlight", {
                                attrs: {
                                  text:
                                    relationship.company ||
                                    relationship.facility ||
                                    "—",
                                  search: _vm.resultSearch,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          relationship.company &&
                          relationship.facility &&
                          relationship.facility !== relationship.company
                            ? _c(
                                "div",
                                [
                                  _c("admin-directory-highlight", {
                                    attrs: {
                                      text: relationship.facility,
                                      search: _vm.resultSearch,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          relationship.dba
                            ? _c(
                                "div",
                                [
                                  _vm._v("\n            DBA:\n            "),
                                  _c("admin-directory-highlight", {
                                    attrs: {
                                      text: relationship.dba,
                                      search: _vm.resultSearch,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  [relationship.city, relationship.state]
                                    .filter(Boolean)
                                    .join(", ")
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "small",
                            [
                              _c("admin-directory-highlight", {
                                attrs: {
                                  text: relationship.license_number,
                                  search: _vm.resultSearch,
                                  normalize: "license",
                                },
                              }),
                              _vm._v(" "),
                              relationship.license_number &&
                              relationship.license_type
                                ? _c("span", [
                                    _vm._v("\n              ·\n            "),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                "\n\n            " +
                                  _vm._s(relationship.license_type) +
                                  "\n          "
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }
                  )
                },
              },
              {
                key: "cell(source)",
                fn: function ({ item }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.sources[item.source] || item.source) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.total > _vm.perPage
            ? _c("b-pagination", {
                attrs: { "total-rows": _vm.total, "per-page": _vm.perPage },
                on: { input: _vm.load },
                model: {
                  value: _vm.page,
                  callback: function ($$v) {
                    _vm.page = $$v
                  },
                  expression: "page",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Contact details", size: "lg", "ok-only": "" },
          model: {
            value: _vm.detailVisible,
            callback: function ($$v) {
              _vm.detailVisible = $$v
            },
            expression: "detailVisible",
          },
        },
        [
          _vm.selected
            ? [
                _c("h5", [_vm._v(_vm._s(_vm.contactName(_vm.selected)))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.selected.title || "No title available") +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("dl", { staticClass: "row" }, [
                  _c("dt", { staticClass: "col-sm-4" }, [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "col-sm-8" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.selected.email || "—") +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "col-sm-4" }, [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "col-sm-8" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.selected.phone || "—") +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", { staticClass: "col-sm-4" }, [
                    _vm._v("Greenlists account"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { staticClass: "col-sm-8" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.selected.account_status) +
                          "\n\n          "
                      ),
                      _vm.selected.source === "user"
                        ? _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "admin-user",
                                  params: { id: _vm.selected.source_id },
                                },
                              },
                            },
                            [_vm._v("\n            Open user\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("dt", { staticClass: "col-sm-4" }, [_vm._v("Source")]),
                  _vm._v(" "),
                  _c("dd", { staticClass: "col-sm-8" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.sources[_vm.selected.source] ||
                            _vm.selected.source
                        ) +
                        "\n          #" +
                        _vm._s(_vm.selected.source_id) +
                        "\n        "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("h6", [_vm._v("Companies, facilities and licenses")]),
                _vm._v(" "),
                !_vm.selected.relationships ||
                !_vm.selected.relationships.length
                  ? _c("p", { staticClass: "text-muted" }, [
                      _vm._v("\n        No linked company or license.\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(
                  _vm.selected.relationships || [],
                  function (relationship, index) {
                    return _c(
                      "b-card",
                      {
                        key: `selected-relationship-${index}`,
                        staticClass: "mb-2",
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                relationship.company ||
                                  relationship.facility ||
                                  "Company unavailable"
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        relationship.company_id && _vm.canReadCompanies
                          ? _c(
                              "router-link",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  to: {
                                    name: "admin-company",
                                    params: { id: relationship.company_id },
                                  },
                                },
                              },
                              [_vm._v("\n          Open company\n        ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        relationship.company_status
                          ? _c("div", [
                              _vm._v(
                                "\n          Company status: " +
                                  _vm._s(relationship.company_status) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        relationship.dba
                          ? _c("div", [
                              _vm._v(
                                "\n          DBA: " +
                                  _vm._s(relationship.dba) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        relationship.facility
                          ? _c("div", [
                              _vm._v(
                                "\n          Facility: " +
                                  _vm._s(relationship.facility) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                [
                                  relationship.license_number,
                                  relationship.license_type,
                                  relationship.license_status,
                                ]
                                  .filter(Boolean)
                                  .join(" · ")
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                [
                                  relationship.address,
                                  relationship.city,
                                  relationship.state,
                                ]
                                  .filter(Boolean)
                                  .join(", ")
                              ) +
                              "\n        "
                          ),
                        ]),
                        _vm._v(" "),
                        relationship.state_license_id
                          ? _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "admin-state-license-detail",
                                    params: {
                                      id: relationship.state_license_id,
                                    },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          Open State License\n        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }
                ),
                _vm._v(" "),
                _vm.canCreate
                  ? _c(
                      "b-button",
                      {
                        attrs: { variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.openCreate(_vm.selected)
                          },
                        },
                      },
                      [_vm._v("\n        Link company or license\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected.possible_duplicates &&
                _vm.selected.possible_duplicates.length
                  ? [
                      _c("h6", { staticClass: "mt-3" }, [
                        _vm._v("Possible matching contacts"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "text-muted" }, [
                        _vm._v(
                          "\n          These records share an email or phone. They have not been merged.\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.selected.possible_duplicates,
                        function (match) {
                          return _c(
                            "div",
                            { key: `${match.source}:${match.source_id}` },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showContact(match)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.contactName(match)) +
                                      " ·\n            " +
                                      _vm._s(
                                        _vm.sources[match.source] ||
                                          match.source
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.form.existing_source
              ? "Link existing contact"
              : "Add directory contact",
            busy: _vm.saving,
            "ok-title": "Save",
            "ok-disabled": _vm.saving,
          },
          on: {
            hidden: _vm.cancelLookups,
            ok: function ($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
          model: {
            value: _vm.createVisible,
            callback: function ($$v) {
              _vm.createVisible = $$v
            },
            expression: "createVisible",
          },
        },
        [
          _c(
            "b-alert",
            { attrs: { show: Boolean(_vm.formError), variant: "danger" } },
            [_vm._v("\n      " + _vm._s(_vm.formError) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.duplicateCandidates.length
            ? _c(
                "div",
                { staticClass: "mb-3" },
                [
                  _c("p", [
                    _vm._v(
                      "\n        Use an existing contact to retain its original record and add your\n        selected relationships:\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.duplicateCandidates, function (person) {
                    return _c(
                      "b-button",
                      {
                        key: `${person.source}:${person.source_id}`,
                        attrs: { block: "", variant: "outline-primary" },
                        on: {
                          click: function ($event) {
                            return _vm.reuseContact(person)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.contactName(person)) +
                            " ·\n        " +
                            _vm._s(
                              _vm.sources[person.source] || person.source
                            ) +
                            "\n      "
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2",
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.keepSeparate },
                    },
                    [
                      _vm._v(
                        "\n        Create a separate contact anyway\n      "
                      ),
                    ]
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.form.existing_source
            ? _vm._l(_vm.contactFields, function (field) {
                return _c(
                  "b-form-group",
                  {
                    key: field.key,
                    attrs: {
                      label: field.label,
                      "label-for": `contact-${field.key}`,
                      "invalid-feedback": _vm.validation[field.key],
                      state: _vm.fieldState(field.key),
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: {
                        id: `contact-${field.key}`,
                        type: field.key === "email" ? "email" : "text",
                        state: _vm.fieldState(field.key),
                      },
                      model: {
                        value: _vm.form[field.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, field.key, $$v)
                        },
                        expression: "form[field.key]",
                      },
                    }),
                  ],
                  1
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Companies",
                "label-for": "directory-company-lookup",
              },
            },
            [
              _c("v-select", {
                attrs: {
                  "input-id": "directory-company-lookup",
                  multiple: "",
                  label: "name",
                  options: _vm.companyLookup.options,
                  filterable: false,
                  loading: _vm.companyLookup.loading,
                  placeholder: "Type to search companies",
                },
                on: { search: (value) => _vm.scheduleLookup("company", value) },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function () {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.lookupHint(_vm.companyLookup, "companies")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.chosenCompanies,
                  callback: function ($$v) {
                    _vm.chosenCompanies = $$v
                  },
                  expression: "chosenCompanies",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: !_vm.companyLookup.error } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.companyLookup.error) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: {
                label: "Facilities / State Licenses",
                "label-for": "directory-license-lookup",
              },
            },
            [
              _c("v-select", {
                attrs: {
                  "input-id": "directory-license-lookup",
                  multiple: "",
                  label: "label",
                  options: _vm.licenseLookup.options,
                  filterable: false,
                  loading: _vm.licenseLookup.loading,
                  placeholder: "Type a facility, DBA or license number",
                },
                on: { search: (value) => _vm.scheduleLookup("license", value) },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function () {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.lookupHint(
                                _vm.licenseLookup,
                                "facilities or licenses"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.chosenLicenses,
                  callback: function ($$v) {
                    _vm.chosenLicenses = $$v
                  },
                  expression: "chosenLicenses",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: !_vm.licenseLookup.error } },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.licenseLookup.error) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n      License information is read directly from the State License tool.\n    "
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }